import styled from "styled-components";

export const ProfileBlankSpace = styled.div`
  height: 30px;
`
export const CustomInput = styled.div`

width: "400px",
height: "45px",
marginBottom: "7px"
`